(() => {
  let chatHost = null;
  let chatResizeObserver = null;
  let chatStyleObserver = null;
  let chatWatchStarted = false;
  let syncFrame = 0;

  // Only inspect the public Inbox host. The app owns its chat UI and behavior.
  const syncLauncherVisibility = () => {
    const nextChat = document.querySelector('shopify-chat');
    if (nextChat !== chatHost) {
      chatResizeObserver?.disconnect();
      chatStyleObserver?.disconnect();
      chatHost = nextChat;
      if (chatHost) {
        if ('ResizeObserver' in window) {
          chatResizeObserver = new ResizeObserver(requestLauncherSync);
          chatResizeObserver.observe(chatHost);
        }
        chatStyleObserver = new MutationObserver(requestLauncherSync);
        chatStyleObserver.observe(chatHost, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    }
    const rect = chatHost?.getBoundingClientRect();
    const style = chatHost ? getComputedStyle(chatHost) : null;
    const inboxVisible = Boolean(chatHost?.isConnected && rect.width > 0 && rect.height > 0 &&
      style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0');
    document.querySelectorAll('[data-hco-launcher]').forEach(launcher => {
      // Never remove a menu or focus target the visitor is currently using.
      launcher.hidden = inboxVisible && !launcher.open && !launcher.contains(document.activeElement);
    });
  };
  const requestLauncherSync = () => {
    if (syncFrame) return;
    syncFrame = requestAnimationFrame(() => {
      syncFrame = 0;
      syncLauncherVisibility();
    });
  };
  const watchInbox = () => {
    if (chatWatchStarted) return;
    chatWatchStarted = true;
    const observer = new MutationObserver(records => {
      const hostChanged = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.matches('shopify-chat') || node.querySelector('shopify-chat'))));
      if (hostChanged) requestLauncherSync();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', requestLauncherSync, { passive: true });
    document.addEventListener('visibilitychange', requestLauncherSync);
    requestLauncherSync();
  };
  const initialize = () => {
    document.querySelectorAll('[data-hco-launcher]').forEach(launcher => {
      if (launcher.dataset.hcoReady === 'true') return;
      launcher.dataset.hcoReady = 'true';
      launcher.addEventListener('toggle', requestLauncherSync);
      launcher.addEventListener('focusout', requestLauncherSync);
      const summary = launcher.querySelector('summary');
      const close = (restoreFocus = false) => {
        launcher.open = false;
        if (restoreFocus) summary.focus();
      };
      const closeButton = launcher.querySelector('[data-hco-close]');
      if (closeButton) {
        closeButton.hidden = false;
        closeButton.addEventListener('click', () => close(true));
      }
      launcher.querySelector('[data-hco-email-link]')?.addEventListener('click', event => {
        const href = event.currentTarget.getAttribute('href');
        const target = href?.startsWith('#') ? document.getElementById(href.slice(1)) : null;
        const input = target?.querySelector('input[type="email"]');
        close();
        if (input) requestAnimationFrame(() => input.focus({ preventScroll: true }));
      });
      document.addEventListener('pointerdown', event => {
        if (launcher.open && !launcher.contains(event.target)) close();
      });
      launcher.addEventListener('keydown', event => {
        if (event.key === 'Escape' && launcher.open) {
          event.preventDefault();
          close(true);
        }
      });
    });
    watchInbox();
    document.querySelectorAll('[data-hco-contact]').forEach(section => {
      const form = section.querySelector('.hco-form');
      if (!form || form.dataset.hcoReady === 'true') return;
      form.dataset.hcoReady = 'true';

      const storageKey = `holubo-contact-return:${form.id}`;
      const success = form.querySelector('[data-hco-success]');
      const error = form.querySelector('[data-hco-error]');
      const fields = form.querySelector('[data-hco-fields]');
      const isPreview = ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
      let pendingReturn = false;
      try {
        const pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        pendingReturn = Boolean(pending && pending.path === location.pathname &&
          Number.isFinite(pending.at) && Date.now() - pending.at >= 0 &&
          Date.now() - pending.at < 30 * 60 * 1000);
      } catch (_) {
        // The form still works when browser storage is unavailable.
      }

      // Shopify renders these nodes only for an actual native form state.
      // A query parameter or a submit click alone never creates a success state.
      const isThisFormReturn = location.hash === `#${form.id}` || pendingReturn;
      if (isThisFormReturn && (success || error)) {
        const feedback = success || error;
        feedback.hidden = false;
        if (success && fields) fields.hidden = true;
        if (error) {
          const email = form.querySelector('input[type="email"]');
          if (email) email.setAttribute('aria-invalid', 'true');
        }
        requestAnimationFrame(() => {
          feedback.focus({ preventScroll: true });
          form.scrollIntoView({ block: 'center', behavior: 'auto' });
        });
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
      }

      form.addEventListener('submit', event => {
        if (isPreview) {
          event.preventDefault();
          const notice = form.querySelector('[data-hco-preview]');
          if (notice) notice.hidden = false;
          return;
        }
        try {
          // Store only a short-lived return marker, never the visitor's inputs.
          sessionStorage.setItem(storageKey, JSON.stringify({ path: location.pathname, at: Date.now() }));
        } catch (_) {}
        // Preserve Shopify's native action, validation and spam protection.
      });

      // A submission through another contact form must not claim our result.
      document.querySelectorAll('form').forEach(otherForm => {
        if (otherForm === form || !otherForm.querySelector('input[name="form_type"][value="contact"]')) return;
        otherForm.addEventListener('submit', () => {
          try { sessionStorage.removeItem(storageKey); } catch (_) {}
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
